import {
  LS_QUIZ_AUDIO_KEYS,
  QUIZ_AUDIO_PREFS_EVENT,
  readQuizAudioPrefs,
} from '@/utils/quizAudioPrefs';
import { getQuizBgmUrl } from '@/utils/quizBgmUrl';

/** Một Audio element cho cả SPA — không tạo lại khi đổi route. */
let audioEl = null;
let browserUnlocked = false;
let routeEnabled = true;

function applyBgmVolume(el, musicVolPercent) {
  const v = musicVolPercent / 100;
  el.volume = Math.min(1, 0.14 + v * 0.55);
}

function ensureAudio() {
  if (audioEl) return audioEl;
  const el = new Audio(getQuizBgmUrl());
  el.loop = true;
  el.preload = 'auto';
  audioEl = el;
  return el;
}

function pauseBgm() {
  if (!audioEl) return;
  try {
    audioEl.pause();
  } catch {
    /* ignore */
  }
}

/**
 * Gọi sau gesture người dùng (pointer/keydown) hoặc khi SFX đã mở AudioContext.
 * Bật phát nếu prefs.musicOn.
 */
export function unlockGlobalQuizBgm() {
  browserUnlocked = true;
  syncGlobalQuizBgmFromPrefs();
}

/** Đọc prefs hiện tại: bật/tắt, âm lượng, phát/tạm dừng. */
export function syncGlobalQuizBgmFromPrefs() {
  const prefs = readQuizAudioPrefs();
  if (!prefs.musicOn || !routeEnabled) {
    pauseBgm();
    return;
  }
  if (!browserUnlocked) return;
  const el = ensureAudio();
  applyBgmVolume(el, prefs.musicVol);
  if (el.paused) {
    void el.play().catch(() => {});
  }
}

export function setGlobalQuizBgmRouteEnabled(enabled) {
  routeEnabled = Boolean(enabled);
  syncGlobalQuizBgmFromPrefs();
}

let installRefCount = 0;

/**
 * Gắn vào App (một lần trong lifecycle thật). Lắng nghe prefs + lần đầu chạm/phím để mở phát nhạc.
 */
export function installGlobalQuizBgm() {
  installRefCount += 1;
  if (installRefCount > 1) {
    return () => {
      installRefCount -= 1;
    };
  }

  const onPrefs = () => syncGlobalQuizBgmFromPrefs();
  const onStorage = (e) => {
    if (e.key && LS_QUIZ_AUDIO_KEYS.has(e.key)) onPrefs();
  };

  const tryUnlock = () => {
    unlockGlobalQuizBgm();
  };

  window.addEventListener(QUIZ_AUDIO_PREFS_EVENT, onPrefs);
  window.addEventListener('storage', onStorage);
  window.addEventListener('pointerdown', tryUnlock, { once: true, capture: true });
  window.addEventListener('keydown', tryUnlock, { once: true, capture: true });

  return () => {
    installRefCount -= 1;
    if (installRefCount > 0) return;
    window.removeEventListener(QUIZ_AUDIO_PREFS_EVENT, onPrefs);
    window.removeEventListener('storage', onStorage);
    window.removeEventListener('pointerdown', tryUnlock, { capture: true });
    window.removeEventListener('keydown', tryUnlock, { capture: true });
  };
}
